import { Stack, Typography } from '@mui/material'
import IconFromStatus from '../IconFromStatus'
import { displayNames } from '../requiredExpertFormData'

const PhysicianStatus = ({ status }: { status: string }) => (
    <Stack flexDirection="row" alignItems="center">
        <IconFromStatus status={status} />
        <Typography
            sx={{
                display: {
                    xs: 'none',
                    sm: 'block',
                },
            }}
        >
            {displayNames[status]}
        </Typography>
    </Stack>
)

export default PhysicianStatus
